import { FC } from "react";
import { setIsChangePlan } from "../../redux/slices/vehicleFilterSlice";
import { BiChevronLeft } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import PlanCard from "../addVehicle/PlanCard";
import { useQuery, useMutation } from "@apollo/client";
import { GET_PLANS, UPDATE_VEHICLE_PLAN } from "../../apollo/operations";
import { showToast } from "../../utils/showToast";
import { PlanType } from "../../types";
import { Loading } from "..";

const EditPlan: FC = () => {
  const isChangePlan = useSelector(
    (state: RootState) => state.vehicleFilter.isChangePlan
  );

  const dispatch = useDispatch();

  const { data, loading } = useQuery(GET_PLANS, {
    variables: {
      where: {
        isLesseePlan: false,
      },
    },
    onCompleted(data) {
      // console.log(data.plans);
    },
    onError(error) {
      showToast(error.message, "error");
    },
  });

  const handlePlanSelect = (id: string) => {
    dispatch(
      setIsChangePlan({
        carId: isChangePlan?.carId ?? "",
        planId: id,
      })
    );
  };

  const [updateVehiclePlan, { loading: uploadingLoading }] = useMutation(
    UPDATE_VEHICLE_PLAN,
    {
      variables: {
        vehicleId: isChangePlan?.carId ?? "",
        planId: isChangePlan?.planId ?? "",
      },
      onCompleted: () => {
        dispatch(setIsChangePlan(null));
        showToast("Vehicle Plan updated successfully", "success");
        window.scrollTo(0,0)
      },
      onError: (error) => {
        showToast(error.message, "error");
      },
    }
  );

  const handleUpdate = () => {
    // console.log(isChangePlan);
    updateVehiclePlan();
  };

  if (!isChangePlan) return null;

  if (uploadingLoading) {
    return <Loading loading={uploadingLoading} />;
  }
  return (
    <div className=" bg-white/50 flex flex-col gap-5 w-full max-w-[80%] mx-auto py-10 md:py-20 ">
      <div className=" w-full flex items-center ">
        <div
          onClick={() => dispatch(setIsChangePlan(null))}
          className="flex items-center gap-2 cursor-pointer"
        >
          <BiChevronLeft className=" text-[#3D475C] text-2xl" />
          <span className=" font-Jakarta font-normal text-base text-darkGreen">
            Back
          </span>
        </div>
        <span className=" font-Jakarta w-full text-center text-base font-semibold text-midGreen">
          Edit Vehicle Plan
        </span>
      </div>
      <div className=" container bg-white shadow-md rounded-[10px] min-h-screen p-5 md:p-10 flex flex-col gap-7 ">
        {data?.plans?.length && (
          <div className="flex items-center w-[80%] mx-auto justify-around gap-10 flex-wrap  ">
            {data.plans.map((plan: PlanType, index: number) => (
              <PlanCard
                key={index}
                plan={plan}
                currPlanId={isChangePlan.planId ?? ""}
                handleSelectPlan={handlePlanSelect}
              />
            ))}
          </div>
        )}
        <div className="flex justify-end w-full">
          <button
            onClick={() => handleUpdate()}
            className=" bg-midGreen ml-auto text-white w-[200px] h-12 rounded-xl"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPlan;
